/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { PermitTableModule } from '../permit-table/permit-table.module';
import { CreateWindowsLocalAccessGroupComponent } from './create-windows-local-access-group.component';

@NgModule({
    declarations: [CreateWindowsLocalAccessGroupComponent],
    exports: [CreateWindowsLocalAccessGroupComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        FormsModule,
        PermitTableModule,
    ],
})
export class CreateWindowsLocalAccessGroupModule { }
